import { useEffect, useState } from "react";
import { getExperiences } from "../services/api";
import ExperienceCard from "./ExperienceCard";

function Experience() {
    const [experiences, setExperiences] = useState([]);
    
    useEffect(() => {
        getExperiences().then(setExperiences).catch(console.error);
    }, []);

    return (
        <section>
            <h2>Experiència professional</h2>
            {experiences.map((exp) => (
                <ExperienceCard key={exp.id} experience={exp} />
            ))}
        </section>
    );
}

export default Experience;